import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { VerticalDivider } from '@ecp/common/src/layouts/flex/styled';
import { TextButton } from '@ecp/common/src/components/button/bo/TextButton';

const CoMenuApiHis = () => {
  const navigate = useNavigate();

  const handleClick = useCallback(() => {
    navigate('/client/member/acc-api-history');
  }, [navigate]);

  return (
    <>
      <VerticalDivider height="6px" />
      <TextButton onClick={handleClick}>사용이력</TextButton>
    </>
  );
};

export default CoMenuApiHis;
